var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chart',{staticClass:"echart",attrs:{"option":_vm.option,"autoresize":_vm.autoresize,"loading":_vm.loading,"theme":_vm.theme},on:{"click":_vm.onChartClick,"mouseover":_vm.onChartMouseover,"mouseout":_vm.onChartMouseout,"finished":_vm.onChartFinished}})
}
var staticRenderFns = []

export { render, staticRenderFns }